import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import DemoBar from "./DemoBar";
import BottomNav from "./BottomNav";
import { AiHelp } from "./AiHelp";
import { WhatsNewModal } from "./WhatsNewModal";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function Layout() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [approveCount, setApproveCount] = useState(0);
  const [verInfo, setVerInfo] = useState(null);
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    api.appVersion().then((d) => { setVerInfo(d); if (d.should_show) setShowWhatsNew(true); }).catch(() => {});
  }, [user]);

  useEffect(() => {
    if (["foreman", "project_manager", "admin"].includes(user?.role)) {
      api.timesheets().then((ts) =>
        setApproveCount(ts.filter((t) => ["Soumise", "Approuvée contremaître"].includes(t.status)).length)
      ).catch(() => {});
    }
  }, [user]);

  // Mobile: transforme automatiquement les tableaux en cartes lisibles (étiquette chaque valeur via l'en-tête de colonne)
  useEffect(() => {
    const labelTables = () => {
      document.querySelectorAll("table.tbl").forEach((tbl) => {
        tbl.classList.add("as-cards");
        const wrap = tbl.closest(".tbl-wrap");
        if (wrap) wrap.classList.add("cards-mobile");
        const heads = Array.from(tbl.querySelectorAll("thead th")).map((th) => th.textContent.trim());
        tbl.querySelectorAll("tbody tr").forEach((tr) => {
          Array.from(tr.children).forEach((td, i) => {
            if (heads[i] && !td.getAttribute("data-label")) td.setAttribute("data-label", heads[i]);
          });
        });
      });
    };
    labelTables();
    const main = document.querySelector(".content");
    if (!main) return;
    const obs = new MutationObserver(() => labelTables());
    obs.observe(main, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, [location.pathname]);

  return (
    <div className="app-shell">
      <Sidebar open={open} onClose={() => setOpen(false)} approveCount={approveCount} user={user} />
      {open && <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, background: "var(--overlay)", zIndex: 35 }} />}
      <div className="main-area">
        <Topbar onMenu={() => setOpen(true)} />
        <DemoBar />
        <main className="content"><Outlet /></main>
        <footer data-testid="app-footer" style={{ textAlign: "center", padding: "18px 16px 22px", fontSize: 12, color: "var(--muted)", borderTop: "1px solid var(--border-soft)" }}>
          © {new Date().getFullYear()} PROGÈRE™ — PROGÈRE PUNCH · {t("footer.tagline")}
          {verInfo?.version && <span data-testid="app-version" style={{ marginLeft: 8, opacity: .8 }}>· v{verInfo.version}</span>}
        </footer>
      </div>
      <BottomNav onMenu={() => setOpen(true)} user={user} approveCount={approveCount} />
      <AiHelp authed />
      {showWhatsNew && <WhatsNewModal info={verInfo} onClose={() => setShowWhatsNew(false)} />}
    </div>
  );
}
